import { Result } from "../../../models/Result";
import { httpService } from "../../HttpService";
import { StructuredAddress, StructuredAddressAvailability, StructuredAddressLookupResponse, StructuredAddressRequest } from "../../../models/StructuredAddress";

class StructuredAddressApiService {

    async getCustomerStructuredAddress(individualId: number): Promise<Result<StructuredAddressLookupResponse>> {
        try {
            const endpoint = `/KycSubmission/${individualId}/get-structured-address`;
            
            const response = await httpService.get<StructuredAddressLookupResponse>(endpoint);
            
            return response;
        } catch (error) {
            console.error('GET API Error:', error);
            return {
                success: false,
                data: null!,
                message: "Failed to fetch structured address"
            };
        }
    }

    async createCustomerStructuredAddress(individualId: number, request: StructuredAddressRequest): Promise<Result<StructuredAddress>> {
        try {
            const endpoint = `/KycSubmission/${individualId}/create-structured-address`;
            
            const response = await httpService.post<StructuredAddress>(endpoint, request);
            
            return response;
        } catch (error) {
            console.error('CREATE API Error:', error);
            return {
                success: false,
                data: null!,
                message: "Failed to create structured address"
            };
        }
    }

    async modifyCustomerStructuredAddress(individualId: number, request: StructuredAddressRequest): Promise<Result<StructuredAddress>> {
        try {
            const endpoint = `/KycSubmission/${individualId}/modify-structured-address`;
            
            const response = await httpService.post<StructuredAddress>(endpoint, request);
            
            return response;
        } catch (error) {
            console.error('MODIFY API Error:', error);
            return {
                success: false,
                data: null!,
                message: "Failed to modify structured address"
            };
        }
    }

   async checkStructuredAddressAvailability(individualId: number): Promise<Result<StructuredAddressAvailability>> {
        try {
            const endpoint = `/KycSubmission/${individualId}/check-structured-address-availability`;
            
            const response = await httpService.get<StructuredAddressAvailability>(endpoint);
            
            return response;
        } catch (error) {
            console.error('Check Availability API Error:', error);
            return {
                success: false,
                data: null!,
                message: "Failed to check structured address availability"
            };
        }
    }
}

export const structuredAddressApiService = new StructuredAddressApiService();